import { toast } from "react-toastify";
import { post, put, get, remove } from "sr/utils/axios";
import ApiResponse from "sr/models/ApiResponse";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { Bidding } from "sr/models/Bidding";

export const createBidding = async (postData: any) => {
  try {
    return await post<ApiResponse<Bidding>>("/corporate/biddings", postData).then(
      (res) => {
        if (res.success === true) {
          toast.success(res.message || "Bidding created successfully");
          return res;
        } else {
          toast.error(res.error?.message || "Failed to create bidding");
          return null;
        }
      }
    );
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};

export const updateBidding = async (id: string, postData: any) => {
  try {
    return await put<ApiResponse<Bidding>>(`/corporate/biddings/${id}`, postData).then(
      (res) => {
        if (res.success === true) {
          toast.success(res.message || "Bidding updated successfully");
          return res;
        } else {
          toast.error(res.error?.message || "Failed to update bidding");
          return null;
        }
      }
    );
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};

export const getBiddings = async (params: any = {}) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    return await get<ApiResponse<Bidding[]>>(
      `/corporate/biddings${queryParams ? `?${queryParams}` : ""}`
    ).then((res) => {
      if (res.success === true) {
        return res;
      } else {
        toast.error(res.error?.message || "Failed to fetch biddings");
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};

export const getBiddingDetails = async (id: string) => {
  try {
    return await get<ApiResponse<Bidding>>(`/corporate/biddings/${id}`).then(
      (res) => {
        if (res.success === true) {
          return res;
        } else if (res.data) {
          console.warn("API returned error but with usable data:", res);
          return res;
        } else {
          toast.error(res.error?.message || "Failed to fetch bidding details");
          return null;
        }
      }
    );
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};

export const deleteBidding = async (id: string) => {
  try {
    return await remove<ApiResponse<[]>>(`/corporate/biddings/${id}`).then(
      (res) => {
        if (res.success === true) {
          SuccessMessage("API.SUCCESS.CORPORATE.BIDDING.DELETE");
          return res;
        } else {
          HandleApiError(res.error?.message);
          return null;
        }
      }
    );
  } catch (e: any) {
    HandleApiError(e);
  }
};

